<template>
  <div class="max-w-4xl mx-auto">
    <!-- 页面标题 -->
    <div class="text-center mb-12">
      <h1 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-neutral-800 mb-4">Cookie政策</h1>
      <p class="text-neutral-500 max-w-2xl mx-auto">EliteShop 重视您的隐私保护，本政策将说明我们如何使用Cookie及相关技术</p>
    </div>

    <div class="bg-white rounded-lg shadow-elevation-1 p-8 space-y-6">
      <!-- 政策更新时间 -->
      <div class="text-sm text-neutral-500">
        <p>最后更新时间：2025年1月1日</p>
      </div>

      <!-- 什么是Cookie -->
      <section>
        <h2 class="text-xl font-semibold mb-4">1. 什么是Cookie</h2>
        <p class="text-neutral-600 mb-3">
          Cookie是小型的文本文件，当您访问网站时，网站会将Cookie存储在您的设备上。
          Cookie可以存储您的偏好设置、登录状态等信息，帮助网站提供更个性化的服务。
        </p>
        <p class="text-neutral-600">
          Cookie通常包含域名、有效期、标识符等信息，不会包含您的个人身份信息，但可以用于识别您的设备。
        </p>
      </section>

      <!-- 我们如何使用Cookie -->
      <section>
        <h2 class="text-xl font-semibold mb-4">2. 我们如何使用Cookie</h2>
        <p class="text-neutral-600 mb-3">
          EliteShop 使用Cookie主要用于以下目的：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li><strong>必要Cookie</strong>：保障网站基本功能运行，如购物车、登录状态等。禁用此类Cookie可能导致部分功能无法使用。</li>
          <li><strong>性能Cookie</strong>：收集网站使用数据，分析访问量、页面加载速度等，帮助我们优化网站性能和用户体验。</li>
          <li><strong>功能Cookie</strong>：记住您的偏好设置，如语言、地区、显示设置等，提供个性化体验。</li>
          <li><strong>营销Cookie</strong>：用于广告投放和个性化推荐，根据您的浏览行为展示相关商品和优惠信息。</li>
        </ul>
        <p class="text-neutral-600">
          我们不会使用Cookie收集您的敏感个人信息，如身份证号、银行卡信息等。
        </p>
      </section>

      <!-- Cookie的第三方使用 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">3. Cookie的第三方使用</h2>
        <p class="text-neutral-600 mb-3">
          我们的部分合作伙伴可能会在我们的网站上设置Cookie，主要包括：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li>支付服务商（如微信支付、支付宝）：用于处理支付流程</li>
          <li>分析工具（如百度统计、Google Analytics）：用于分析网站流量和用户行为</li>
          <li>广告服务商：用于精准投放广告</li>
          <li>社交媒体插件：用于分享和登录功能</li>
        </ul>
        <p class="text-neutral-600">
          这些第三方Cookie的使用受其自身隐私政策约束，我们无法控制其使用方式。
        </p>
      </section>

      <!-- 如何管理Cookie -->
      <section>
        <h2 class="text-xl font-semibold mb-4">4. 如何管理Cookie</h2>
        <p class="text-neutral-600 mb-3">
          您可以通过以下方式管理Cookie：
        </p>
        <ul class="space-y-3 text-neutral-600 pl-5 list-disc mb-4">
          <li>
            <strong>浏览器设置</strong>：您可以在浏览器设置中查看、删除、阻止Cookie。
            不同浏览器的操作方式略有不同：
            <ul class="pl-5 list-circle mt-2 space-y-1">
              <li>Chrome：设置 > 隐私和安全 > 网站设置 > Cookie和网站权限</li>
              <li>Firefox：选项 > 隐私和安全 > Cookie和网站数据</li>
              <li>Safari：偏好设置 > 隐私 > Cookie和网站数据</li>
              <li>Edge：设置 > Cookie和网站权限</li>
            </ul>
          </li>
          <li><strong>网站设置</strong>：您可以在本网站的Cookie提示框中选择接受或拒绝非必要Cookie</li>
          <li><strong>清除Cookie</strong>：您可以随时清除已存储的Cookie，但这可能导致您需要重新登录网站</li>
        </ul>
        <p class="text-neutral-600 mb-3">
          请注意，禁用某些Cookie可能会影响网站功能的正常使用，如购物车、登录状态等。
        </p>
      </section>

      <!-- Cookie的有效期 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">5. Cookie的有效期</h2>
        <p class="text-neutral-600 mb-3">
          不同类型的Cookie有不同的有效期：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc mb-4">
          <li><strong>会话Cookie</strong>：仅在您的浏览器会话期间有效，关闭浏览器后自动删除</li>
          <li><strong>持久Cookie</strong>：有效期从几天到几年不等，具体取决于Cookie类型和用途</li>
          <li><strong>必要Cookie</strong>：通常为会话Cookie，保障网站基本功能</li>
          <li><strong>分析和营销Cookie</strong>：通常有效期较长，一般为6个月至2年</li>
        </ul>
      </section>

      <!-- 政策更新 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">6. 政策更新</h2>
        <p class="text-neutral-600 mb-3">
          我们可能会根据法律法规变化、业务发展需要更新本Cookie政策。
          重大变更我们会通过网站公告、弹窗提示等方式通知您。
        </p>
        <p class="text-neutral-600">
          建议您定期查看本政策，了解我们如何使用Cookie。
        </p>
      </section>

      <!-- 联系我们 -->
      <section>
        <h2 class="text-xl font-semibold mb-4">7. 联系我们</h2>
        <p class="text-neutral-600 mb-3">
          如果您对我们的Cookie政策有任何疑问或建议，欢迎通过以下方式联系我们：
        </p>
        <ul class="space-y-2 text-neutral-600 pl-5 list-disc">
          <li>客服热线：400-123-4567</li>
          <li>客服邮箱：privacy@eliteshop.com</li>
          <li>联系表单：<router-link to="/contact-us" class="text-primary hover:underline">点击此处</router-link></li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookiePolicy'
}
</script>